'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var PlayerStates = {exports: {}};

exports.PlayerStates = PlayerStates;
